document.addEventListener('DOMContentLoaded', function() {
  // Scroll buttons for featured collections
  document.querySelectorAll('button.carat-previous').forEach(button => {
    button.addEventListener('click', event => {
      let container = button.closest('div').querySelector('div.grid-overflow-wrapper');
      let scrollAmount = button.closest('div').querySelector('div.grid__item').getBoundingClientRect().width;
      container.scrollLeft -= scrollAmount*1.25;
    });
  });
  
  document.querySelectorAll('button.carat-next').forEach(button => {
    button.addEventListener('click', event => {
      let container = button.closest('div').querySelector('div.grid-overflow-wrapper');
      let scrollAmount = button.closest('div').querySelector('div.grid__item').getBoundingClientRect().width;
      container.scrollLeft += scrollAmount*1.25;
    });
  });

  // Quick shop buttons for mobile add to cart
  let quickShopButtons = document.querySelectorAll('button.quick-add-mobile');

  quickShopButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      let variantId = button.dataset.variantId;
      const quickShopOrigin = window.location.pathname;
      let quickShopSrc = button.dataset.quickAddSrc;
      let quickShopTitle = button.dataset.quickAddTitle;
      let shopTheLook = button.dataset.shopTheLook;
      if (quickShopSrc === "") {
        if (quickShopOrigin.includes('/collections')) { 
          quickShopSrc = 'Collection: ' + window.location.pathname.split('/collections/')[1];
        } 
        else if (quickShopOrigin.includes('/search')) {
          const searchQuery = window.location.search.split('=')[1].split('&')[0];
          quickShopSrc = 'Search: ' + decodeURIComponent(searchQuery).replace(/\+/g, ' ');
        }
      } 
      else if (quickShopSrc === "Hotspots") {
        quickShopSrc = 'Shop the Look';
      }
      else {
        quickShopSrc = `${quickShopTitle}: ${quickShopSrc}`;
      }
      quickAddMobile(variantId, quickShopSrc, shopTheLook);
    });
  });

  // Quick add all button for hotspots section
  document.querySelectorAll('button.quick-add-all').forEach(button => {
    button.addEventListener('click', function() {
      let productVars = button.dataset.addAllVars;
      let shopTheLook = button.dataset.shopTheLook;
      addAllVariants(productVars, shopTheLook);
    });
  });
});

function quickAddMobile(variantId, quickShopSrc, shopTheLook) {
  // Create base properties object
  const baseProperties = {
    '_quick_shop': quickShopSrc
  };
  
  // Add 'Part of' property only if shopTheLook exists
  if (shopTheLook) {
    baseProperties['Part of'] = shopTheLook;
  }

  let formData = {
    'items': [{
      'id': variantId,
      'quantity': 1,
      'properties': baseProperties
    }]
  };
   
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
   })
   .then(response => {
    return response.json();
   })
   .then(data => {
    let product = data;
    addedItemToCart(product);
   })
   .catch((error) => {
    console.error('Error:', error);
  });
  
  function addedItemToCart(product) {
    try {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product },
        bubbles: true
      }));
    } catch (error) {
      console.error('Error dispatching ajaxProduct:added event', error);
    }
  }
}

function addAllVariants(variantIds, shopTheLook) {
  const items = variantIds.split(',').map(id => ({
    'id': parseInt(id.trim()),
    'quantity': 1,
    'properties': {
      '_quick_shop': `Shop the Look [Add All]`,
      'Part of Look': shopTheLook
    }
  }));

  let formData = { items };
   
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
   })
   .then(response => {
    return response.json();
   })
   .then(data => {
    addedItemsToCart(data);
   })
   .catch((error) => {
    console.error('Error:', error);
  });
  
  function addedItemsToCart(cartData) {
    try {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { 
          product: cartData,
          isMultipleAdd: true
        },
        bubbles: true
      }));
    } catch (error) {
      console.error('Error dispatching ajaxProduct:added event', error);
    }
  }
}

// Free Shipping Progress Bar
class FreeShippingProgressBar extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.threshold = this.getAttribute('threshold') * 100;
    this.amountRemaining = this.threshold - this.getAttribute('cart-total');
    this.freeShippingProgress = this.amountRemaining > 0 
      ? (this.getAttribute('cart-total') / this.threshold) * 100
      : 100;

    this.render();
    this.setupEventListeners();
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
        }
        progress {
          border-radius: 50%; 
          width: 100%;
          height: 15px;
        }
        progress::-webkit-progress-bar {
          background-color: white;
          border-radius: 20px;
        }
        progress::-webkit-progress-value {
          background-color: var(--shipping-bar-color, #000);
          border-radius: 20px;
        }
        .label {
          cursor: unset;
          font-weight: unset;
          font-size: var(--shipping-bar-font-size, 1rem);
          text-align: center;
          margin-bottom: 0;
        }
        .progress-bar-container {
          display: flex;
          justify-content: center;
          margin: 0 auto;
          border: 2px solid black;
          border-radius: 20px;
        }
      </style>

      <div id="shipping-bar-container">
        <p class="label">${this.getMessageContent()}</p>
        <div class="progress-bar-container">
          <progress max="100" value="${this.freeShippingProgress}">
            ${this.freeShippingProgress}%
          </progress>
        </div>
      </div>
    `;
  }

  getMessageContent() {
    if (this.amountRemaining > 0) {
      let message = this.getAttribute('message-before');
      message = message.replace('{{amount_remaining}}', this.formatMoney(this.amountRemaining));
      return message;
    }
    return this.getAttribute('success-message');
  }

  setupEventListeners() {
    document.addEventListener('cart:updated', (evt) => this.updateProgress(evt.detail.cart));
    document.addEventListener('ajaxProduct:added', () => {
      fetch('/cart.js')
        .then(response => response.json())
        .then(data => this.updateProgress(data))
        .catch((error) => console.error('Error:', error));
    });
  }

  updateProgress(cart) {
    this.amountRemaining = this.threshold - cart.items_subtotal_price;
    this.freeShippingProgress = cart.items_subtotal_price / this.threshold * 100;
    
    const progressEl = this.shadowRoot.querySelector('progress');
    const labelEl = this.shadowRoot.querySelector('.label');
    
    if (this.amountRemaining > 0) {
      labelEl.innerHTML = this.getMessageContent();
      progressEl.value = this.freeShippingProgress;
      progressEl.textContent = `${this.freeShippingProgress}%`;
    } else {
      labelEl.innerHTML = this.getAttribute('success-message');
      progressEl.value = 100;
      progressEl.textContent = `${this.freeShippingProgress}%`;
    }
  }

  formatMoney(amount) {
    return theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
  }
}

customElements.define('free-shipping-progress-bar', FreeShippingProgressBar); 